import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-edit-section-header',
  templateUrl: './edit-section-header.component.html',
  styleUrls: ['./edit-section-header.component.scss']
})
export class EditSectionHeaderComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  @Input() closeButton = false;
  @Input() closeText!: string;

  constructor() {}

  ngOnInit(): void {}
}
